import { useQuery } from "@apollo/client"
import { createContext, useContext } from "react"
// Note: not importing from "@pathwright/media-client" due to circular dep.
// import { MUX_VIDEO_EMBED_QUERY } from "@pathwright/media-client"
import { MUX_VIDEO_EMBED_QUERY } from "./mux-graphql"

const MuxEmbedContext = createContext<any>({})
export const useMuxEmbed = () => useContext(MuxEmbedContext)

const MuxGraphQLEmbedProvider = ({
  children,
  id
}: {
  id: string
  children: React.ReactNode
}) => {
  const { data, loading, error, refetch } = useQuery(MUX_VIDEO_EMBED_QUERY, {
    variables: { id },
    fetchPolicy: "cache-and-network",
    skip: !id
  })

  const passValue = {
    embed: data?.muxVideoEmbed,
    loading,
    error,
    refetch
  }

  return (
    <MuxEmbedContext.Provider value={passValue}>
      {children}
    </MuxEmbedContext.Provider>
  )
}

type EmbedProviderProps = {
  id: string
  contextKey: string // should be, if possible, a unique key across all rendered components
  children: React.ReactNode
  isLocal?: boolean
}

const MuxEmbedProvider = ({ children, ...props }: EmbedProviderProps) => {
  if (props.isLocal) {
    console.log(
      `Cannot render Mux videos without a server connection. Video id: ${props.id}`
    )
    return null
  }

  return (
    <MuxGraphQLEmbedProvider
      // We want a unique key here if possible to avoid Apollo caching issues
      key={`mux-embed-provider-${props.id}-${props.contextKey}`}
      {...props}
    >
      {children}
    </MuxGraphQLEmbedProvider>
  )
}

export default MuxEmbedProvider
